// Geolocation app content translation for DE

window.addEventListener("DOMContentLoaded", function() {
  let executed = false;
  let count = 0;
  const maxRetries = 400;
  const delay = 50;

  function updateModalContent() {
    const recommendationModal = document.querySelector(".recommendation-modal__container");

    if (recommendationModal) {
      const recommendationModalMessage = recommendationModal.querySelector(".recommendation-modal__content .recommendation-modal__message");
      if (recommendationModalMessage) {
        const updatedMessage = recommendationModalMessage.innerHTML.replace("Dein Standort ist ", "Ihr Standort ist ").replace("Deine Sprache ist ", "Ihre Sprache ist ");
        if (recommendationModalMessage.innerHTML !== updatedMessage) {
          recommendationModalMessage.innerHTML = updatedMessage;
        }
      }
      executed = true; // Stop further attempts once the modal is updated
    } else if (count < maxRetries) {
      count++;
      setTimeout(updateModalContent, delay); // Try again after a delay
    }
  }

  updateModalContent();
});